import { Admin } from './sections/Admin';
import { AffiliationMarketplace } from './sections/AffiliationMarketplace';
import { Agencies } from './sections/Agencies';
import { AgentAccountSettings } from './sections/AgentAccountSettings';
import { AgentDocuments } from './sections/AgentDocuments';
import { AgentMarketing } from './sections/AgentMarketing';
import { AgentOwnerLeads } from './sections/AgentOwnerLeads';
import { Agents } from './sections/Agents';
import { Applications } from './sections/Applications';
import { BankAccounts } from './sections/BankAccounts';
import { Bookings } from './sections/Bookings';
import { Calendar } from './sections/Calendar';
import { Documents } from './sections/Documents';
import { Home } from './sections/Home';
import { Incidents } from './sections/Incidents';
import { Investment } from './sections/Investment';
import { Invoices } from './sections/Invoices';
import { Marketplace } from './sections/Marketplace';
import { NonPayments } from './sections/NonPayments';
import { OrganizationServices } from './sections/OrganizationServices';
import { OwnerAccountSettings } from './sections/OwnerAccountSettings';
import { Payments } from './sections/Payments';
import { People } from './sections/People';
import { Portfolio } from './sections/Portfolio';
import { Solvency } from './sections/Solvency';
import { Supplies } from './sections/Supplies';
import { TaskManager } from './sections/TaskManager';
import { Taxes } from './sections/Taxes';
import { Team } from './sections/Team';
import { Templates } from './sections/Templates';
import { Valuations } from './sections/Valuations';

export interface SectionProps {
  onClickItem?: () => void;
  depth?: number;
  isMobile: boolean;
}

export const Sections = {
  Admin,
  Agencies,
  Agents,
  AgentAccountSettings,
  AgentDocuments,
  AffiliationMarketplace,
  Applications,
  BankAccounts,
  Bookings,
  Calendar,
  Documents,
  Home,
  Incidents,
  Investment,
  Marketplace,
  OrganizationServices,
  OwnerAccountSettings,
  Payments,
  People,
  Portfolio,
  Solvency,
  Supplies,
  TaskManager,
  Taxes,
  Team,
  Templates,
  Valuations,
  Invoices,
  NonPayments,
  AgentOwnerLeads,
  AgentMarketing
};
